// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./QuestionModal.module.scss";

import Modal from "components/Modal/Modal";
// import Question from "./Question/Question";

import FormElement from "components/FormElement/FormElement";
import Select from "components/Select/Select";
import Button from "components/Button/Button";
// import DateInput from "components/DateInput/DateInput"
import Radio from "components/Radio/Radio";
import Row from "components/Row/Row";

import {
    // loadUsersAction,
    // loadSitesAction,
    // createTaskAction,
    completeTaskAction
} from "store/actions/Actions";
import { toggleDropdowns } from "helpers/utils";

const QuestionModal = (props) => {

    const { completeTaskAction } = props;

    const question = {
        id: props.data.id,
        question: props.data.question,
        answer: props.data.answer || '',
        task: props.data.task,
        risk: props.data.risk || '5',
        notes: props.data.notes || '',
        disabled: props.data.isComplete === "t" ? true : false,
    }

    const [state, setState] = useState(question);

    // const [stateErrors, setStateErrors] = useState({
    //     task: "",
    //     due: "",
    //     assignee: "",
    //     selected_site: {},
    // });

    // const { answerQuestionAction } = props;

    const assigneeDropdownRef = React.createRef();
    const riskDropdownRef = React.createRef();

    const handleFinalize = () => {
        completeTaskAction([
            {
                id: state.task,
                answer: state.answer === '' ? '3' : state.answer,
                risk: state.risk,
                notes: state.notes,
                completed: true,
                subtask: 'audit_response',
            }
        ]);
        props.setShowModal(false);
    }

    const handleChange = (name) => (e) => {
        console.log(name, e.target.value);
        const value = e.target.value;
        setState((s) => ({
            ...s,
            [name]: value,
        }));
        e.persist();
        console.log(e.target.value);
    }

    return (
        <Modal
            className={styles.modal}
            setShowModal={props.setShowModal}
            
        >
            <div onClick={toggleDropdowns([
                assigneeDropdownRef,
                riskDropdownRef,
            ])}>
                <p className={styles["modal-heading"]}>Question Task</p>

                <div className={styles["modal-content"]}>

                    <div>
                        <p className={styles.question}>{state.question}</p>
                    </div>

                    <FormElement htmlFor="answer">
                        <Row className={styles["status-row"]}>
                            {/* 2 = Yes */}
                            <Radio
                                disabled={state.disabled}
                                checked={state.answer === "2"}
                                labelText="Yes"
                                onChange={handleChange('answer')}
                                value="2"
                            />
                            {/* 1 = No */}
                            <Radio
                                disabled={state.disabled}
                                checked={state.answer === "1"}
                                labelText="No"
                                onChange={handleChange('answer')}
                                value="1"
                            />
                            {/* 3 = Not Applicatble */}
                            <Radio
                                disabled={state.disabled}
                                checked={state.answer === "3" || state.answer === "4"}
                                labelText="Not Applicable"
                                onChange={handleChange('answer')}
                                value="3"
                            />
                            {/* 0 = Assign */}
                            {/* <Radio
                                // disabled={disabled}
                                checked={state.answer === "4"}
                                labelText="Assign"
                                onChange={handleChange('answer')}
                                value="4"
                            /> */}
                        </Row>
                    </FormElement>

                    <br />

                    <div className={styles.answer_holder}>
                        <FormElement
                            className={styles.risk}
                            htmlFor="risk"
                            labelText="DEGREE OF RISK"
                        >
                            <Select
                                labels={{
                                    '1': '1 (Minimal risk)',
                                    '2': '2',
                                    '3': '3',
                                    '4': '4 (Average risk)',
                                    '5': '5',
                                    '6': '6',
                                    '7': '7 (High risk)',
                                    '8': '8',
                                    '9': '9',
                                    '10': '10',
                                }}
                                disabled={state.disabled}
                                value={state.risk}
                                onClick={handleChange('risk')}
                                dropdownToggleRef={riskDropdownRef}
                            >
                                <li value="1">1 (Minimal risk)</li>
                                <li value="2">2</li>
                                <li value="3">3</li>
                                <li value="4">4 (Average risk)</li>
                                <li value="5">5</li>
                                <li value="6">6</li>
                                <li value="7">7 (High risk)</li>
                                <li value="8">8</li>
                                <li value="9">9</li>
                                <li value="10">10</li>
                            </Select>
                        </FormElement>
                    </div>

                    <br />

                    <div>
                        <FormElement
                            className={styles.notes}
                            htmlFor="notes"
                            labelText="NOTES"
                        >
                            <textarea
                                disabled={state.disabled}
                                className={styles.textarea}
                                rows="5"
                                onChange={handleChange('notes')}
                                value={state.notes}
                            />
                        </FormElement>
                    </div>

                </div>

                <div className={styles["modal-footer"]}>
                    <Button
                        text="CLOSE"
                        color="secondary"
                        onClick={() => props.setShowModal(false)}
                    />
                    {!state.disabled && <Button
                        text="FINALIZE TASK"
                        className={styles.create}
                        onClick={handleFinalize}
                    />}
                </div>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    // UsersReducer: state.UsersReducer,
    // SitesReducer: state.SitesReducer
});

const mapDispatchToProps = {
    completeTaskAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionModal);
